import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import createDefaultActionDefinition from '../common/actionDefinition/default';

const borderAction = createDefaultActionDefinition(
  StylesDerivedNativeActions.borderStyles,
);

export default borderAction;
